import React, {
  ReactNode,
  RefObject,
} from 'react';
import clsx from 'clsx';
import Label from '@/components/Label';

type Part = 'label' | 'container' | 'root';

export type Props = {
  className?: string;
  labelClasses?: string;
  containerClassName?: string;
  id: string;
  label?: string | ReactNode;
  required?: boolean;
  children?: ReactNode;
  error?: boolean;
  showErrorText?: boolean;
  classes?: Partial<Record<Part, string>>;
  wrapperRef?: RefObject<HTMLDivElement>;
};

export default function Wrapper({
  className,
  labelClasses,
  containerClassName,
  id,
  label,
  required,
  children,
  error,
  showErrorText = true,
  classes,
  wrapperRef,
}: Props) {
  const containerClasses = clsx(
    'w-full relative flex',
    containerClassName,
  );

  return (
    <div
      ref={wrapperRef}
      className={clsx(
        'flex flex-col space-y-0.5 relative',
        className,
        classes?.root,
        { 'has-error': error },
      )}
    >
      {typeof label === 'string' ? (
        <Label
          className={clsx(labelClasses, classes?.label)}
          id={id}
          label={label}
          required={required}
        />
      ) : label}
      {error && showErrorText && (
        <span className="absolute right-0 !text-xs text-red-500 font-semibold -top-1">
          Invalid entry
        </span>
      )}
      <div className={clsx(containerClasses, classes?.container)}>
        {children}
      </div>
    </div>
  );
}
